import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faSignOutAlt,
  faChevronDown,
  faArrowRight,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import logo from "assets/images/logo/big barrister-1.webp"; // Replace with actual path
import Cookies from "js-cookie";
import { useSelector, useDispatch } from "react-redux";
import { handlingApi } from "units/handlingApi";
import { changeAuthenticated, setUser } from "Slices/theme/reducer";
import toast from "react-hot-toast";

const ChatTopBar = ({ setSelectedMode, selectedMode }) => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const user = useSelector((state) => state.theme.user);
  const isAuthenticated = useSelector((state) => state.theme.isAuthenticated);
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [confirmLogout, setConfirmLogout] = useState(false);
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);
  const profileRef = useRef(null);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleConfirmLogout = () => {
    setConfirmLogout(true);
  };

  const handleLogout = async () => {
    const token = Cookies.get("token");
    if (token) {
      setLoading(true);
      const url = `${apiBaseUrl}user/logout`;

      try {
        const res = await handlingApi({ url, method: "POST", data: {}, token });

        if (res.statusCode === 200) {
          Cookies.remove("token");
          dispatch(changeAuthenticated(false));
          dispatch(setUser(null));
          localStorage.removeItem("userData");
          setLoading(false);
          setConfirmLogout(false);
          navigate("/");
          toast.success(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      <div className="topbar d-flex align-items-center justify-content-between px-3 py-2">
        {/* Left - Logo */}
        <div className="topbar-logo">
          <img
            src={logo}
            width={180}
            alt="Logo"
            onClick={() => navigate("/")}
          />
        </div>

        {/* Center - Dropdown for Chat and Document Generation */}
        {/* {isAuthenticated && (
          <div className="topbar-dropdown" ref={dropdownRef}>
            <button
              className="dropdown-toggle btn btn-light"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              {selectedMode} <FontAwesomeIcon icon={faChevronDown} />
            </button>
            {dropdownOpen && (
              <ul className="dropdown-menu show">
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setSelectedMode("Legal ChatBot");
                      navigate("/chatbot");
                    }}
                  >
                    Chat with Bot
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setSelectedMode("Legal Document");
                      navigate("/chatbot");
                    }}
                  >
                    Generate Legal Document
                  </button>
                </li>
              </ul>
            )}
          </div>
        )} */}

        {/* Right - Profile Dropdown */}

        {isAuthenticated ? (
          <div className="topbar-profile" ref={profileRef}>
            <button
              className="btn btn-light dropdown-toggle"
              onClick={() => setProfileOpen(!profileOpen)}
            >
              {user?.fName[0]}
              {user?.lName[0]}
            </button>
            {profileOpen && (
              <ul className="dropdown-menu show dropdown-menu-end">
                <li className="m-0">
                  <span className="dropdown-item-text pb-0">
                    Logged in as {user?.email || "User"}
                  </span>
                </li>
                <li className="m-0">
                  <button
                    className="dropdown-item"
                    onClick={() => navigate("/profile")}
                  >
                    Profile
                  </button>
                </li>
                <li className="m-0">
                  <button
                    className="dropdown-item text-danger"
                    onClick={handleConfirmLogout}
                  >
                    <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                  </button>
                </li>
              </ul>
            )}
          </div>
        ) : (
          <>
            <Link to="/login" className="chatbot-btn">
              Sign In
            </Link>
          </>
        )}
      </div>

      {confirmLogout && (
        <div style={{ zIndex: "9999999" }} className="popup-overlay">
          <div className="popup-container mt-5">
            <span
              className="close-btn"
              onClick={() => {
                setConfirmLogout(false);
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </span>
            <h3 className="mb-0 mb-md-4 text-center">
              <span>Confirm Logout</span>
            </h3>
            <p className="text-center mb-2">Are you sure you want to log out</p>
            <p className="mb-3">
              of Strafinfo Chatbot? <strong>{user?.email}</strong>
            </p>
            <div className="d-flex justify-content-center gap-3 pt-3">
              <button
                onClick={() => {
                  setConfirmLogout(false);
                }}
                className="btn btn-secondary geex-content__header__popup__footer__link fs-3"
                style={{ padding: "1rem 2rem", borderRadius: "10px" }}
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="btn btn-primary geex-content__header__popup__footer__link fs-3"
                style={{
                  padding: "1rem 2rem",
                  borderRadius: "10px",
                  marginRight: "1rem",
                }}
                disabled={loading}
              >
                {loading ? (
                  <div className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <>
                    Logout
                    <FontAwesomeIcon icon={faArrowRight} />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatTopBar;
